import React, { useState, useEffect } from 'react';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-swift';
import 'prismjs/components/prism-http';
import 'prismjs/themes/prism-tomorrow.css';
import styles from './CodeSnippet.module.scss';

const languageMap = {
  curl: 'bash',
  shell: 'bash',
  javascript: 'javascript',
  node: 'javascript',
  python: 'python',
  html: 'markup',
  xml: 'markup',
  c: 'c',
  cpp: 'cpp',
  java: 'java',
  php: 'php',
  csharp: 'csharp',
  swift: 'swift',
  http: 'http',
};

const CodeSnippet = ({ examples, language }) => {
  const [code, setCode] = useState('');

  useEffect(() => {
    if (examples && language && examples[language]) {
      setCode(examples[language]);
    } else if (examples) {
      const firstLanguage = Object.keys(examples)[0];
      if (firstLanguage) {
        setCode(examples[firstLanguage] || '');
      }
    }
  }, [language, examples]);

  const highlightCode = (code) => {
    const prismLanguage = languageMap[language] || 'javascript';
    if (languages[prismLanguage]) {
      return highlight(code, languages[prismLanguage], prismLanguage);
    }
    return code; // No highlighting if language is not loaded
  };

  return (
    <div className={styles.codeSnippet} style={{ flexGrow: 1 }}>
      <div className={styles.codeSnippetHeader}>
        cURL
      </div>
      <Editor
        value={code}
        onValueChange={() => {}}
        highlight={highlightCode}
        readOnly={true}
        padding={15}
        style={{
          fontFamily: '"Fira Code", "Fira Mono", monospace',
          fontSize: 'var(--font-size-base)',
          lineHeight: '1.5',
          flexGrow: 1,
          overflow: 'auto',
        }}
      />
    </div>
  );
};

export default CodeSnippet;